module.exports = __webpack_public_path__ + "static/img/91BM-068-LiuZhu.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-068-LiuZhu.jpg
// module id = Az9N
// module chunks = 0